import { FC } from "react";

export const EmailIcon: FC<{ className?: string }> = ({ className }) => {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.55384 20.1496C3.09385 20.1496 2.69498 19.9808 2.35721 19.643C2.01946 19.3052 1.85059 18.9064 1.85059 18.4464V5.55398C1.85059 5.09236 2.01946 4.69208 2.35721 4.35315C2.69498 4.0142 3.09385 3.84473 3.55384 3.84473H20.4462C20.9079 3.84473 21.3081 4.0142 21.6471 4.35315C21.986 4.69208 22.1555 5.09236 22.1555 5.55398V18.4464C22.1555 18.9064 21.986 19.3052 21.6471 19.643C21.3081 19.9808 20.9079 20.1496 20.4462 20.1496H3.55384ZM12 12.6415L3.55384 7.06648V18.4464H20.4462V7.06648L12 12.6415ZM12 11.004L20.3462 5.55398H3.67884L12 11.004ZM3.55384 7.06648V5.55398V18.4464V7.06648Z"
        fill="currentColor"
      />
    </svg>
  );
};
